import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';

const actions = {
    getAwatTemplate: {
        method: 'GET',
        url: `${BASE_PATH_API}/awatsettings`
    },
    getAwatDefaultTemplateStages: {
        method: 'GET',
        url: `${BASE_PATH_API}/awatsettings/availableStages`
    },
    getAvailableDefaultAwatTemplateSteps: {
        method: 'GET',
        url: `${BASE_PATH_API}/awatsettings/availableSteps`
    },
    deleteUnpublishedAwatTemplate: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/awatsettings`
    },
    createUnpublishedAwatTemplate: {
        method: 'POST',
        url: `${BASE_PATH_API}/awatsettings`
    },
    publishUnpublishedAwatTemplate: {
        method: 'PUT',
        url: `${BASE_PATH_API}/awatsettings/publish`
    },
};

export function AwatSettingsApi() {
    return createActions(actions);
}
